import React from 'react';

const cards = [
  { badge: '24/7', title: 'NOC/SOC monitoring', points: ['Continuous system monitoring', 'Proactive issue detection', 'Zero-downtime SLA target'] },
  { badge: 'Named', title: 'Dedicated account manager', points: ['Single point of contact', 'Quarterly performance reviews', 'Strategic optimisation advice'] },
  { badge: 'SLA', title: 'Helpdesk & ticketing', points: ['Jira-based ticketing', 'Phone support included', 'Structured escalation matrix'] },
  { badge: '↑', title: 'Built to grow with you', points: ['From 10 to 100+ agents seamlessly', 'Custom features, fast delivery', 'Modular setup — add what you need'] },
];

export default function Support() {
  return (
    <div id="enterprise" style={{ background: '#0a0a0a', borderTop: '1px solid rgba(10,158,143,0.13)', borderBottom: '1px solid rgba(10,158,143,0.13)' }}>
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '5rem 2.5rem' }}>
        <div style={tag}>// SUPPORT & INFRASTRUCTURE</div>
        <h2 style={head}>Enterprise support.<br /><span style={{ color: '#0a9e8f' }}>Not enterprise excuses.</span></h2>
        <div className="support-grid" style={{ marginTop: '2.5rem', background: 'rgba(10,158,143,0.13)', borderRadius: 12, overflow: 'hidden' }}>
          {cards.map((c, i) => (
            <div key={i} style={{ background: '#060606', padding: '2rem', transition: 'background .2s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#0a0a0a'}
              onMouseLeave={e => e.currentTarget.style.background = '#060606'}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem' }}>
                <div style={{ width: 36, height: 36, borderRadius: 7, background: 'rgba(10,158,143,0.12)', border: '1px solid rgba(10,158,143,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#0a9e8f', fontFamily: "'JetBrains Mono', monospace" }}>{c.badge}</span>
                </div>
                <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: '#f0f0f0' }}>{c.title}</div>
              </div>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 7 }}>
                {c.points.map((p, j) => (
                  <li key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.8rem', color: '#c0c0c0', fontWeight: 300 }}>
                    <span style={{ width: 4, height: 4, borderRadius: '50%', background: '#056055', flexShrink: 0 }} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const tag = { fontSize: '0.68rem', color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: 12, borderLeft: '2px solid #056055', paddingLeft: 10 };
const head = { fontSize: 'clamp(1.6rem,3vw,2.2rem)', fontWeight: 700, letterSpacing: '-0.03em', color: '#f0f0f0', lineHeight: 1.2 };
